import { JsonSchemaValidator } from "@common/json-schema-validator";

export const brandLogoDataFile = {
  [JsonSchemaValidator.isFile]: true
};
